export default defineNuxtPlugin(async (nuxtApp) => {
  if (typeof window === 'undefined') {
    return
  }
  const config = useRuntimeConfig()
  const buildTimeConfig = {
    stripePublishableKey: config.public.stripePublishableKey || '',
  }
  try {
    const response = await $fetch('/api/stripe-config')
    const stripeConfig = {
      stripePublishableKey:
        response.stripePublishableKey || buildTimeConfig.stripePublishableKey,
    }
    nuxtApp.provide('stripeConfig', stripeConfig)
    try {
      if (response.stripePublishableKey) {
        config.public.stripePublishableKey = response.stripePublishableKey
      }
    } catch (e) {
      console.error('[stripe-config] Error fetching stripe config:', e)
    }
  } catch (error) {
    nuxtApp.provide('stripeConfig', buildTimeConfig)
    console.error('[stripe-config] Error in catch block:', error)
  }
})
